import { setAdminData } from 'store/reducers/adminUser';
import {
  entitySettingsFailure,
  entitySettingsRequest,
  entitySettingsSuccess,
} from 'store/reducers/entitySettings';
import {
  teamUserServicesFailure,
  teamUserServicesRequest,
  teamUserServicesSuccess,
  teamUsersFailure,
  teamUsersRequest,
  teamUsersSuccess,
} from 'store/reducers/groomers';
import {
  userFailure,
  userRequest,
  userSetCredentials,
  userSuccess,
} from 'store/reducers/user';

import { fetchData } from './fetchData';

export const loadUser = (userId, actions) => (dispatch, getState) => {
  const { uuid, token } = getState().user;
  return fetchData({
    endpoint: `user/${userId || uuid}`,
    actions: actions || [userRequest, userSuccess, userFailure],
  })(dispatch, getState).then(({ success, data }) => {
    if (success) {
      const { isAdmin, name } = data.data;
      const { uuid: adminUuid } = getState().adminUser;
      // Set admin data if user is admin & there's no other admin data stored (this
      // would mean you're impersonating an admin)
      if (isAdmin && !adminUuid) dispatch(setAdminData({ uuid, token, name }));
    }
    return { success, data };
  });
};

export const impersonateUser = (uuid) => (dispatch, getState) =>
  fetchData({
    endpoint: `user/${uuid}/impersonate`,
    actions: [null, null, null],
  })(dispatch, getState).then(({ success, data }) => {
    if (success) {
      dispatch(userSetCredentials(data.data));
      dispatch(loadUser(data.data.uuid));
    }
  });

export const getTeamUsers = () => (dispatch, getState) => {
  const { providerUsers, locations } = getState().user;
  const puid = providerUsers.provider.uuid;
  const luid = locations[0]?.uuid;

  return fetchData({
    endpoint: `provider/${puid}/location/${luid}/users`,
    actions: [teamUsersRequest, teamUsersSuccess, teamUsersFailure],
  })(dispatch, getState);
};

export const getTeamUser = (uuid) => (dispatch, getState) => {
  const { uuid: puid, locations } = getState().provider;
  const luid = locations[0]?.uuid;
  return fetchData({
    endpoint: `provider/${puid}/location/${luid}/users/${uuid}`,
    actions: [
      teamUserServicesRequest,
      teamUserServicesSuccess,
      teamUserServicesFailure,
    ],
  })(dispatch, getState);
};

export const createTeamUser = (body) => (dispatch, getState) => {
  const { uuid: puid, locations } = getState().provider;
  const luid = locations[0]?.uuid;
  return fetchData({
    endpoint: `provider/${puid}/location/${luid}/users`,
    actions: [null, null, null],
    httpMethod: 'post',
    body: {
      ...body,
      roleId: 3,
    },
  })(dispatch, getState);
};

export const editTeamUser = (body, uuid) => (dispatch, getState) => {
  const { uuid: puid, locations } = getState().provider;
  const luid = locations[0]?.uuid;
  return fetchData({
    endpoint: `provider/${puid}/location/${luid}/users/${uuid}`,
    actions: [null, null, null],
    httpMethod: 'put',
    body,
  })(dispatch, getState);
};

export const uploadUserAvatar =
  ({ body, uuid }) =>
  (dispatch, getState) =>
    fetchData({
      endpoint: `user/${uuid}/image/upload`,
      actions: [null, null, null],
      httpMethod: 'post',
      isMedia: true,
      body,
    })(dispatch, getState);

export const sendVerificationEmail = (uuid) => (dispatch, getState) => {
  const { uuid: puid, locations } = getState().provider;
  const luid = locations[0]?.uuid;
  return fetchData({
    endpoint: `provider/${puid}/location/${luid}/users/${uuid}/verify`,
    actions: [null, null, null],
    httpMethod: 'post',
  })(dispatch, getState);
};

export const getUserSettings =
  ({ uuid }) =>
  (dispatch, getState) => {
    const { locations } = getState().provider;
    const luid = locations[0]?.uuid;
    return fetchData({
      endpoint: `location/${luid}/user/${uuid}/settings`,
      actions: [
        entitySettingsRequest,
        entitySettingsSuccess,
        entitySettingsFailure,
      ],
    })(dispatch, getState);
  };

export const patchUserSettings =
  ({ uuid, body }) =>
  (dispatch, getState) => {
    const { locations } = getState().provider;
    const luid = locations[0]?.uuid;
    return fetchData({
      endpoint: `location/${luid}/user/${uuid}/settings`,
      actions: [null, null, null],
      body,
      httpMethod: 'patch',
    })(dispatch, getState);
  };
